import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {MainMiniCommon} from './main/MainMiniCommon';

export interface IDashboardMiniMobileViewProps {
    dashboard: any;
}

@observer
export class DashboardMiniMobileView extends TechseeBaseComponent<IDashboardMiniMobileViewProps> {
    renderInternal(): JSX.Element {
        const {dashboard} = this.props;
        const dashboardState = dashboard?.dashboardState;

        if (!dashboardState?.dashboardControllerLoaded || !dashboard.miniDashboard) {
            return <React.Fragment />;
        }

        return (
            <div className='ts-mini-mobile-dashboard-view-area'>
                {/* Main Content - replaces ui-view="mini-mobile-dashboard-view" */}
                <MainMiniCommon main={dashboard} containerClassName='ts-dashboard-mini-dashboard-mobile-container' />
            </div>
        );
    }
}
